import { render, staticRenderFns } from "./NewSaleNote.vue?vue&type=template&id=d8f4352c&scoped=true&"
import script from "./NewSaleNote.vue?vue&type=script&lang=js&"
export * from "./NewSaleNote.vue?vue&type=script&lang=js&"
import style0 from "./NewSaleNote.vue?vue&type=style&index=0&id=d8f4352c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f4352c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f4352c')) {
      api.createRecord('d8f4352c', component.options)
    } else {
      api.reload('d8f4352c', component.options)
    }
    module.hot.accept("./NewSaleNote.vue?vue&type=template&id=d8f4352c&scoped=true&", function () {
      api.rerender('d8f4352c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Invoices/NewSaleNote.vue"
export default component.exports